import script from "./headerInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./headerInfo.vue?vue&type=script&setup=true&lang=js"

import "./headerInfo.vue?vue&type=style&index=0&id=36537454&scoped=true&lang=css"

import exportComponent from "D:\\workspaceJava\\wlyc\\wlyc\\tianjing-client-web-develop\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36537454"]])

export default __exports__